import React, { useEffect, useState } from 'react'
import { HashLink } from 'react-router-hash-link';
import '../css/Navbar.css'
import useWindowSize from "../getWindowDimensions"


function Navbar({ setnavClick }) {
    const size = useWindowSize();
    return (
        <div className="nav__full">
            <p className="nav__name">Shyam Sundar B</p>
            <div className="nav__links">
                <HashLink smooth to="#home" onClick={() => setnavClick(false)}>
                    <p>01</p>
                    ℍ𝕆𝕄𝔼
                </HashLink>
                <HashLink smooth to={size.width > 990 ? "#services" : "#services__mobile"} onClick={() => setnavClick(false)}>
                    <p>02</p>
                    𝕊𝔼ℝ𝕍𝕀ℂ𝔼𝕊
                </HashLink>
                <HashLink smooth to="#about" onClick={() => setnavClick(false)}>
                    <p>03</p>
                    𝔸𝔹𝕆𝕌𝕋
                </HashLink>
                <HashLink smooth to="#skills" onClick={() => setnavClick(false)}>
                    <p>04</p>
                    𝕊𝕂𝕀𝕃𝕃𝕊
                </HashLink>
                <HashLink smooth to="#work" onClick={() => setnavClick(false)}>
                    <p>05</p>
                    𝕎𝕆ℝ𝕂𝕊
                </HashLink>
                <HashLink smooth to="#contact" onClick={() => setnavClick(false)}>
                    <p>06</p>
                    ℂ𝕆ℕ𝕋𝔸ℂ𝕋
                </HashLink>
            </div>
            <div className="nav__social__links">
                <a>Github</a>
                <a>Linked In</a>
                <a>Instagram</a>
            </div>
        </div>
    )
}

export default Navbar
